export const GRID_SIZE = 4;
export const CELL_SIZE = 70; // Base cell size
export const GRID_GAP = 12; // Gap between cells
export const ANIMATION_DURATION = 150; // in ms

export const COLORS = {
  2: { background: '#eee4da', text: '#776e65' },
  4: { background: '#ede0c8', text: '#776e65' },
  8: { background: '#f2b179', text: '#f9f6f2' },
  16: { background: '#f59563', text: '#f9f6f2' },
  32: { background: '#f67c5f', text: '#f9f6f2' },
  64: { background: '#f65e3b', text: '#f9f6f2' },
  128: { background: '#edcf72', text: '#f9f6f2' },
  256: { background: '#edcc61', text: '#f9f6f2' },
  512: { background: '#edc850', text: '#f9f6f2' },
  1024: { background: '#edc53f', text: '#f9f6f2' },
  2048: { background: '#edc22e', text: '#f9f6f2' },
  4096: { background: '#3c3a32', text: '#f9f6f2' },
  8192: { background: '#2a2a2a', text: '#f9f6f2' },
};

export const SWIPE_CONFIG = {
  minDistance: 30, // Minimum distance for a swipe to be registered
  maxTime: 300, // Maximum time in ms for a swipe to be registered
};

export const KEY_CODES = {
  UP: ['ArrowUp', 'KeyW', 'KeyK'],
  DOWN: ['ArrowDown', 'KeyS', 'KeyJ'],
  LEFT: ['ArrowLeft', 'KeyA', 'KeyH'],
  RIGHT: ['ArrowRight', 'KeyD', 'KeyL'],
};